import { Action, Dispatch } from 'redux'
import { openBulkStockModalAction } from 'reducks/modal/actions'

const openBulkStockModal = (date: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openBulkStockModalAction(date))
  }
}

export default openBulkStockModal
